var _path, _rect, _rect2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeCabinetOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 582,
    viewBox: "0 0 428 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428 0H0.59375V26.3719H428V0ZM60.6125 31.8281H370.709V531.984H60.6125V31.8281ZM20.6 537.44H417.997V582H20.6V537.44Z",
    fill: "#984B20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 53,
    width: 276,
    height: 457,
    fill: "#5B2919"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 53,
    width: 14,
    height: 457,
    fill: "#984B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 156H358V169H70V156Z",
    fill: "#984B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 273H356V286H68V273Z",
    fill: "#984B20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69 383H357V396H69V383Z",
    fill: "#984B20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeCabinetOpen);
export default __webpack_public_path__ + "static/media/large_cabinet_open.5f40d53023761661dbda12d8ad17e6c8.svg";
export { ForwardRef as ReactComponent };